export default "__VITE_ASSET__CTMWoQg2__"